import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import {Objects} from "../index";

export default class Outstanding_Invoices extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Outstanding_Invoices._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 50;
		this.state.modalNotes = false;
		this.state.reason = "";
		this.state.notes = "";
		this.state.modalType = 1;
		this.state.selectedPkey = null;
	}

	updateFilterBools = (key) => {
		const current = this.state.filter?.filterBools || {};

		const updated = {
			...current,
			[key]: !current[key]
		};

		this.setState({
			filter: {
				...this.state.filter,
				filterBools: updated
			}
		}, () => {
			this.fetchData();
		});
	};

	fetchData = async (state) => {
		if (typeof(this.state.filter) === "undefined") {
			this.state.filter = {};
		}

		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	updateBoolValue = async (object, key) => {
		let model = new API.BuildClass(Types.Outstanding_Invoices._name, 'POST');
		model.object = object;
		model.object[key] = !!!object[key];
		this.data = await model.submit(null, 'POST');
		await this.fetchData();
	}

	updateTextValue = async () => {
		let model = new API.BuildClass(Types.Outstanding_Invoices._name, 'POST');
		const entry = this.state.data.filter((item) => item.pkey === this.state.selectedPkey)[0];
		const key = this.state.modalType === 1 ? 'notes' : 'reason';
		model.object = entry;
		model.object[key] = this.state[key];
		this.data = await model.submit(null, 'POST');
		await this.fetchData();
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal], reason: "", notes: "", selectedPkey: null})
	}

	render() {
		const {data, pages, limit, loading} = this.state;

		const columns = [
			{
				Header: "Serv. Date",
				width: 100,
				id: "tickets.appointment_start",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.tickets?.appointment_start,
				Cell: (props) => {
					if (props.original.tickets) {
						return <Link to={`/tickets/${props.original.ticket}`}>
							{(moment(props.original.tickets?.appointment_start).format('MM/DD/YYYY'))}
						</Link>
					} else {
						return <span>
							{(moment(props.original.created).format('MM/DD/YYYY'))}
						</span>
					}
				}
			},
			{
				// TODO what tz should this be in?
				Header: "Time",
				id: 'tickets.appointment_start',
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.tickets ? (moment(obj.tickets?.appointment_start).format("HHmm") + '-' + moment(obj.tickets?.appointment_end).format("HHmm")) : (moment(obj.created).format('h:mm a')),
			},
			{
				Header: "FE",
				id: 'tickets.users',
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.fe_name,
			},
			{
				Header: "Client",
				id: 'tickets.customers.name',
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.tickets?.customers.name,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: (props) => {
					if (props.original.tickets) {
						return <Link to={`/customers/${props.original.tickets?.customer}`}>
							{props.original.tickets?.customers.name}
						</Link>
					} else {
						return <span>{props.original.client}</span>
					}
				}
			},
			{
				Header: "Location",
				id: "tickets.ticket_location",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => (obj.customer_city || obj.customer_state) ? (obj.customer_city + ', ' + obj.customer_state) : 'N/A',
			},
			{
				Header: "FD Ticket",
				id: "tickets.fresh_ticket",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => freshdeskTicketExport(obj.tickets?.fresh_ticket || obj.fresh_ticket),
				Cell: props => props.original.tickets
					? <FreshdeskTicketLink freshTicket={props.original.tickets.fresh_ticket} />
					: props.original.fresh_ticket
						? <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						: "N/A",
			},
			{
				Header: "T. Invoice",
				id: "total_invoice",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.total_invoice,
			},
			{
				Header: "Square URL",
				id: "square_url",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.square_url,
				Cell: props => props.original.square_url ? <a
					href={props.original.square_url ?? ""}
					target={'_blank'}>{props.original.square_url }</a> : null,
			},
			{
				Header: "Valid",
				id: "valid",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.valid,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.valid}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'valid')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "First Email",
				id: "first_email",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.first_email,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.first_email}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'first_email')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Phone",
				id: "phone",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.phone,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.phone}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'phone')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Final Email",
				id: "final_email",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.final_email,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.final_email}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'final_email')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Collect.",
				id: "collections",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.collections,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.collections}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'collections')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Edit",
				id: "notes",
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.notes,
				width: 80,
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
								this.setState({modalNotes: true, selectedPkey: props.original.pkey})
							}}>
								<Edit fontSize={"small"} />
							</Button>
						</div>
					);
				}
			},
			{
				Header: "Paid",
				id: "paid",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				/** @param {Outstanding_Invoices_Object} obj */
				accessor: obj => obj.paid,
				/** @param {Outstanding_Invoices_Object} props.original */
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.paid}
								onChange={async () => {
									await this.updateBoolValue(props.original, 'paid')
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
		]

		return (
			<div className={'container-fluid'}>
				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Invoice"}
					object={Objects.OutstandingInvoice}
					toggle={this.state.modalNotes}
					reportClose={this.reportClose('modalNotes')}
					afterSave={() => {
						this.props.triggerReload()
					}}
					id={this.state.selectedPkey}
					hideGoTo={true}
				/>
				<Card>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Outstanding Invoices')}
							<ButtonGroup size={"md"}>
								{[
									{ key: "valid", label: "Valid" },
									{ key: "first_email", label: "1st Email" },
									{ key: "phone", label: "Phone" },
									{ key: "final_email", label: "Final Email" },
									{ key: "collections", label: "Collections" },
									{ key: "paid", label: "Paid" },
								].map(btn => (
									<Button
										key={btn.key}
										onClick={() => this.updateFilterBools(btn.key)}
										active={!!this.state.filter?.filterBools?.[btn.key]}
										outline={!!!this.state.filter?.filterBools?.[btn.key]}
										color={"info"}
									>
										{btn.label}
									</Button>
								))}
							</ButtonGroup>
							{this.renderHeaderRight("Outstanding Invoices",columns)}
						</div>
					</div>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>

			</div>
		)
	}
}
